import { ReactGAImplementation } from "react-ga4";

const KEY = process.env.REACT_APP_GA_KEY;
const IS_DEV =
  process.env.REACT_APP_WEB_ENV === "development" ||
  process.env.REACT_APP_WEB_ENV === "stage";

class GA extends ReactGAImplementation {
  private isEnableGA = false;

  enableGA = () => {
    if (KEY && !this.isEnableGA && !IS_DEV) {
      this.isEnableGA = true;
      this.initialize(KEY);
    }
  };

  trackEvent = (category: string, action: string, label: string) => {
    if (this.isEnableGA) {
      this.event({
        category,
        action,
        label,
      });
    }
  };
}

export const AnalyticsGA = new GA();
